import React, { forwardRef } from "react";
import { FormGroup, FormLabel, FormControl } from "react-bootstrap";
import NumberFormat from "react-number-format";

import "../styles.css";

const TextInput = forwardRef(
  (
    {
      id,
      label = "",
      placeholder = "",
      width = "15%",
      handleEnter,
      handleChange,
      errorText = "",
      isInputNumber = false,
      isTextArea = false,
      value,
      textAreaRows = 5,
      isForm = false,
      inputType = "text",
    },
    ref
  ) => {
    return (
      <div style={{ width: width }}>
        <FormGroup
          className={`${isForm ? "d-flex form-input" : ""} flex-column`}
        >
          <FormLabel htmlFor={`input-text-${id}`}>{label}</FormLabel>
          {isInputNumber ? (
            <div>
              <NumberFormat
                thousandSeparator
                prefix="Rp "
                displayType="input"
                type="text"
                customInput={FormControl}
                id={`input-text-${id}`}
                onValueChange={handleChange}
                value={value}
                isInvalid={!!errorText}
                placeholder={placeholder}
                name={id}
              />
              <FormControl.Feedback type="invalid">
                {errorText}
              </FormControl.Feedback>
            </div>
          ) : isTextArea ? (
            <>
              <FormControl
                id={`input-textarea-${id}`}
                onChange={handleChange}
                placeholder={placeholder}
                name={id}
                isInvalid={!!errorText}
                as={"textarea"}
                value={value}
                rows={textAreaRows}
              />
              <FormControl.Feedback type="invalid">
                {errorText}
              </FormControl.Feedback>
            </>
          ) : (
            <>
              <FormControl
                type={inputType}
                id={`input-text-${id}`}
                onChange={handleChange}
                onKeyDown={handleEnter && handleEnter("enter")}
                onBlur={handleEnter && handleEnter("blur")}
                placeholder={placeholder}
                name={id}
                ref={ref}
                isInvalid={!!errorText}
                value={value}
              />
              <FormControl.Feedback type="invalid">
                {errorText}
              </FormControl.Feedback>
            </>
          )}
        </FormGroup>
      </div>
    );
  }
);

export default TextInput;
